module.exports = __webpack_public_path__ + "static/sui-table-valign-f93302d328eff461e1d4ca3100207c06.png";